export class Task {
    opened: boolean;
    closed: boolean;
    taskType: 'APPROVAL' | 'ADDRESS VERIFICATION' | 'CABLE CUT' | 'REQUESTED DELIVERY DATE' | 'RECEIPT OF GOODS' | 'PROGRAMMABLE PRODUCT';
    worksheetID: string;
    receiptOfGoodsID: string;
    bomLineID: string;
    id: string;
    orderNumber: string;
    accountNumber: string;
    projectName: string;
}

export class MyTasks {
    marketId: string;
    status: string;
    startDate: string;
    endDate: string;
    taskType: string;
}

export class TaskCount{
    taskType: string;
    count: number;
}


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/task.ts